/* ============================= E X P O R T ============================= */

export default {
  name: 'InfoCircle',

  props: {
    color: {
      type: String,
      in: [
        'primary',
        'secundary',
        'blue'
      ]
    }
  }
}
